<template>
  <div v-if="messages.length > 0" class="rich-inbox-message-list pt-050">
    <RichInboxMessageCard
      v-for="message in messages"
      :key="message.id"
      v-bind="message"
      @delete="handleDelete"
      @read="handleRead"
    />
  </div>

  <IllustratedSection
    v-else
    :has-horizontal-margin="false"
    illustration="rich-inbox-empty"
    outlined
    smaller-headline-spacing
  >
    <template #headline>{{ $t('richinbox.empty.headline') }}</template>
    <template #subtitle>{{ $t('richinbox.empty.description') }}</template>
  </IllustratedSection>
</template>

<script lang="ts" setup>
import { RichInboxMessageProps } from './RichInboxMessageCard.vue'

const expandedMessageId = ref<Maybe<string>>(null)

provide(richInboxExpandedIdKey, expandedMessageId)

const messages = ref<RichInboxMessageProps[]>([])

const handleRead = (id: string) => {
  const message = messages.value.find((m) => m.id === id)
  if (message) message.read = true
}

const handleDelete = (id: string) => {
  messages.value = messages.value.filter((m) => m.id !== id)
}
</script>

<style lang="scss" scoped>
.rich-inbox-message-list {
  display: flex;
  flex-direction: column;
  gap: token('size/space/gap/100');
}
</style>
